<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div
      class="form_title_wrapper booking-page-header d-flex justify-content-between align-items-center"
    >
      <h4 class="booking-page-title">
        {{
          $t("PLACEHOLDERS.showBooking", { number: data.booking_number || "" })
        }}
      </h4>
      <div class="booking-header-actions">
        <v-btn
          v-if="canCancelBooking"
          color="error"
          class="booking-cancel-btn"
          :loading="isCancelling"
          :disabled="isCancelling"
          @click="openCancelDialog"
        >
          {{ $t("PLACEHOLDERS.cancelBooking") }}
        </v-btn>
        <v-btn @click="$router.go(-1)" class="booking-back-btn">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Booking Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- ============ Booking Main Info ============ -->
          <h6 class="col-12 mb-3 booking-section-title">
            {{ $t("PLACEHOLDERS.bookingInfo") }}
          </h6>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.booking_number')"
            v-model="data.booking_number"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model="data.status"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.return_vehicle_same_location')"
            v-model="data.return_vehicle_same_location"
            disabled
          />

          <!-- ============ Client Info ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.clientInfo") }}
          </h6>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.client_name')"
            v-model="data.client.name"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.client_phone')"
            v-model="data.client.mobile"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.client_email')"
            v-model="data.client.email"
            disabled
          />
          <!-- ============ Provider Info ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.providerInfo") }}
          </h6>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model="data.provider.name"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_phone')"
            v-model="data.provider.mobile"
            disabled
          />

          <!-- ============ Location Info ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.locationInfo") }}
          </h6>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.pickup_location')"
            v-model="data.pickup_location"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.delivery_location')"
            v-model="data.delivery_location"
            disabled
          />

          <!-- ============ Date Info ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.dateInfo") }}
          </h6>

          <base-input
            col="3"
            type="text"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model="data.date.start_date"
            disabled
          />
          <base-input
            col="3"
            type="text"
            :placeholder="$t('PLACEHOLDERS.start_time')"
            v-model="data.date.start_time"
            disabled
          />
          <base-input
            col="3"
            type="text"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model="data.date.end_date"
            disabled
          />
          <base-input
            col="3"
            type="text"
            :placeholder="$t('PLACEHOLDERS.end_time')"
            v-model="data.date.end_time"
            disabled
          />

          <base-input
            col="3"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_days')"
            v-model="data.date.total_days"
            disabled
          />

          <!-- ============ Vehicle Info ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.vehicleInfo") }}
          </h6>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.brand')"
            v-model="data.vehicle.brand"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.model')"
            v-model="data.vehicle.model"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.model_year')"
            v-model="data.vehicle.model_year"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.license_plate')"
            v-model="data.vehicle.plate_number"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.gear_type')"
            v-model="data.vehicle.gear_type"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.condition')"
            v-model="data.vehicle.condition_status"
            disabled
          />

          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.vehicle_description')"
            v-model="data.vehicle.description"
            disabled
          />

          <!-- ============ Additional Services ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.additionalServices") }}
          </h6>

          <div
            v-for="(service, index) in data.additional_services"
            :key="index"
            class="row"
          >
            <base-input
              col="5"
              type="text"
              :placeholder="$t('PLACEHOLDERS.name')"
              v-model="service.name"
              disabled
            />
            <base-input
              col="4"
              type="text"
              :placeholder="$t('PLACEHOLDERS.price')"
              v-model="service.price"
              disabled
            />
            <base-input
              col="3"
              type="text"
              :placeholder="$t('PLACEHOLDERS.currency')"
              v-model="service.currency"
              disabled
            />
          </div>

          <!-- ============ Payment Summary ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.paymentSummary") }}
          </h6>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_type')"
            v-model="data.payment_type"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_method')"
            v-model="data.payment_method"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_status')"
            v-model="data.payment_status"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.vehicle_price')"
            v-model="data.budget.vehicle_price"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.additional_service_price')"
            v-model="data.budget.additional_service_price"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tax_amount')"
            v-model="data.budget.tax"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.paid_amount')"
            v-model="data.budget.paid_amount"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.remaining_amount')"
            v-model="data.budget.remaining_amount"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.total_amount')"
            v-model="data.budget.total"
            disabled
          />

          <!-- ============ Booking Date ============ -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.booking_date')"
            v-model="data.created_at"
            disabled
          />

          <!-- ============ Cancellation Info ============ -->
          <h6 class="col-12 mb-3 mt-4 booking-section-title">
            {{ $t("PLACEHOLDERS.cancellationInfo") }}
          </h6>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cancelled_by')"
            v-model="data.cancelled_by"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cancellation_reason')"
            v-model="data.cancellation_reason"
            disabled
          />

          <!-- ============ Vehicle Images ============ -->
          <div class="col-12" v-if="data.vehicle_images.length">
            <h6 class="mb-3 booking-section-subtitle">
              {{ $t("PLACEHOLDERS.vehicleImages") }}
            </h6>
            <div class="row">
              <div
                v-for="(image, index) in data.vehicle_images"
                :key="index"
                class="col-3 mb-3"
              >
                <img
                  :src="image.url"
                  :alt="`vehicle image ${index + 1}`"
                  class="vehicle-image"
                  @click="showImageModal(image.url)"
                />
              </div>
            </div>
          </div>

          <!-- ============ Contract Images ============ -->
          <div class="col-12" v-if="data.contract_image">
            <h6 class="mb-3 booking-section-subtitle">
              {{ $t("PLACEHOLDERS.contractImages") }}
            </h6>
            <img
              :src="data.contract_image"
              alt="contract"
              class="vehicle-image"
              @click="showImageModal(data.contract_image)"
            />
          </div>
        </div>
      </form>
    </div>
    <!-- End:: Booking Content -->

    <v-dialog v-model="dialogCancel" max-width="520" persistent>
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("PLACEHOLDERS.cancelBooking") }}
        </v-card-title>
        <v-card-text>
          <p class="cancel-dialog-text">
            {{ $t("PLACEHOLDERS.cancelBookingConfirm") }}
          </p>
          <label class="cancel-reason-field">
            <span>
              {{ $t("PLACEHOLDERS.cancellation_reason") }}
              <span class="required_mark">*</span>
            </span>
            <textarea
              rows="3"
              v-model.trim="cancelReason"
              :placeholder="$t('PLACEHOLDERS.cancellation_reason')"
            ></textarea>
            <small class="hint">{{ $t("PLACEHOLDERS.cancelReasonRequired") }}</small>
          </label>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="modal_confirm_btn"
            :loading="isCancelling"
            :disabled="isCancelling || !cancelReason"
            @click="confirmCancelBooking"
          >
            {{ $t("BUTTONS.ok") }}
          </v-btn>
          <v-btn
            class="modal_cancel_btn"
            :disabled="isCancelling"
            @click="closeCancelDialog"
          >
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const BLOCKED_CANCEL_STATUSES = [
  "cancelled",
  "finished",
  "finished_penalty",
];

export default {
  name: "SingleBooking",
  data() {
    return {
      statusRaw: "",
      dialogCancel: false,
      cancelReason: "",
      isCancelling: false,
      data: {
        booking_number: "",
        client: { name: "", mobile: "", email: "" },
        provider: { name: "", mobile: "" },
        status: "",
        return_vehicle_same_location: "",
        pickup_location: "",
        delivery_location: "",
        date: {
          start_date: "",
          start_time: "",
          end_date: "",
          end_time: "",
          total_days: "",
        },
        vehicle: {
          brand: "",
          model: "",
          model_year: "",
          plate_number: "",
          gear_type: "",
          condition_status: "",
          description: "",
        },
        additional_services: [],
        budget: {
          vehicle_price: "",
          additional_service_price: "",
          tax: "",
          paid_amount: "",
          remaining_amount: "",
          total: "",
        },
        created_at: "",
        payment_type: "",
        payment_method: "",
        payment_status: "",
        cancelled_by: "",
        cancellation_reason: "",
        vehicle_images: [],
        contract_image: "",
      },
    };
  },

  computed: {
    canCancelBooking() {
      return (
        !!this.statusRaw &&
        !BLOCKED_CANCEL_STATUSES.includes(this.statusRaw)
      );
    },
  },

  methods: {
    formatMoney(amount, currency = "") {
      const numericValue = Number(amount) || 0;
      return `${numericValue} ${currency}`.trim();
    },

    getStatusText(status) {
      if (!status) return "-";
      const key = `STATUS.${status}`;
      return this.$te(key) ? this.$t(key) : status;
    },

    openCancelDialog() {
      this.cancelReason = "";
      this.dialogCancel = true;
    },

    closeCancelDialog() {
      this.dialogCancel = false;
      this.cancelReason = "";
    },

    async confirmCancelBooking() {
      if (!this.cancelReason) return;
      this.isCancelling = true;
      try {
        await this.$axios.post(`bookings/${this.$route.params.id}/cancel`, {
          reason: this.cancelReason,
        });
        this.$message.success(this.$t("PLACEHOLDERS.cancelBookingSuccess"));
        this.closeCancelDialog();
        await this.getDataToShow();
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      } finally {
        this.isCancelling = false;
      }
    },

    async getDataToShow() {
      try {
        const res = await this.$axios.get(`bookings/${this.$route.params.id}`);
        const d = res.data.data.Booking;
        const currency = d.budget?.currency || "";
        const totalAmount =
          Number(d.budget?.total ?? d.payment?.total) || 0;
        const deposit = Number(d.budget?.deposit ?? d.payment?.deposit) || 0;
        const paidAmount =
          d.payment?.paid_amount != null
            ? Number(d.payment.paid_amount)
            : d.is_paid
            ? totalAmount
            : Math.min(deposit, totalAmount);
        const remainingAmount =
          d.payment?.remaining_due != null
            ? Number(d.payment.remaining_due)
            : Math.max(totalAmount - paidAmount, 0);

        this.statusRaw = d.status || "";

        this.data = {
          booking_number: d.booking_number,
          client: {
            name: d.client?.name,
            mobile: d.client?.mobile,
            email: d.client?.email,
          },
          provider: {
            name: d.provider?.name,
            mobile: d.provider?.mobile,
          },
          status: this.getStatusText(d.status),
          return_vehicle_same_location: d.return_vehicle_same_location
            ? this.$t("PLACEHOLDERS.yes")
            : this.$t("PLACEHOLDERS.no"),
          pickup_location:
            d.pickup_location?.address || d.pickup_location?.country || "-",
          delivery_location:
            d.delivery_Location?.address ||
            d.delivery_location?.address ||
            d.delivery_Location?.country ||
            d.delivery_location?.country ||
            this.$t("PLACEHOLDERS.same_location"),
          date: {
            start_date: d.date.start_date,
            start_time: d.date.start_time,
            end_date: d.date.end_date,
            end_time: d.date.end_time,
            total_days: d.date.total_days,
          },
          vehicle: {
            brand: d.vehicle.vehicle_model.vehicle_brand.name,
            model: d.vehicle.vehicle_model.name,
            model_year: d.vehicle.model_year,
            plate_number: d.vehicle.plate_number,
            gear_type: d.vehicle.gear_type?.name,
            condition_status: d.vehicle.is_good_condition
              ? this.$t("PLACEHOLDERS.good")
              : this.$t("PLACEHOLDERS.bad"),
            description: d.vehicle.description,
          },
          additional_services: d.additional_service || [],
          payment_type: d.payment_type_trans,
          payment_method:
            d.remaining_payment_method_trans ||
            d.payment_method_trans ||
            d.payment_method ||
            d.remaining_payment_method ||
            "-",
          payment_status: d.is_paid
            ? this.$t("PLACEHOLDERS.paid")
            : this.$t("PLACEHOLDERS.not_paid"),
          budget: {
            vehicle_price: this.formatMoney(d.budget?.vehicle_price, currency),
            additional_service_price: this.formatMoney(
              d.budget?.additional_service_price,
              currency
            ),
            tax: this.formatMoney(d.budget?.tax, currency),
            paid_amount: this.formatMoney(paidAmount, currency),
            remaining_amount: this.formatMoney(remainingAmount, currency),
            total: this.formatMoney(totalAmount, currency),
          },
          created_at: d.created_at,
          cancelled_by: d.canceled_by || d.cancelled_by || "-",
          cancellation_reason: d.cancellation_reason || "-",
          vehicle_images: d.vehicle_images || [],
          contract_image: d.contract_image,
        };
      } catch (err) {
        console.error(err.response?.data?.message || err.message);
      }
    },

    showImageModal(imageUrl) {
      window.open(imageUrl, "_blank");
    },
  },

  created() {
    this.getDataToShow();
  },
};
</script>

<style scoped>
.vehicle-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #e3e9f5;
  box-shadow: 0 10px 20px rgba(18, 38, 63, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.vehicle-image:hover {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 16px 28px rgba(18, 38, 63, 0.14);
}

.single_show_content_wrapper {
  padding: 10px;
}

.booking-page-header {
  margin-bottom: 16px;
  padding: 14px 16px;
  border: 1px solid #e3e9f5;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f5f9ff 100%);
  box-shadow: 0 8px 20px rgba(17, 40, 74, 0.06);
}

.booking-page-title {
  margin: 0;
  color: #173157;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.booking-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.booking-cancel-btn {
  text-transform: none !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}

.booking-back-btn {
  min-width: 42px !important;
  width: 42px;
  height: 42px;
  color: #1f355c !important;
  border-radius: 50% !important;
  border: 1px solid #d7e3fb !important;
  background: #fff !important;
  box-shadow: 0 6px 14px rgba(28, 62, 112, 0.12);
}

.cancel-dialog-text {
  margin: 0 0 14px;
  text-align: center;
}

.cancel-reason-field {
  display: flex;
  flex-direction: column;
  gap: 6px;

  span {
    font-size: 13px;
    font-weight: 600;
  }

  textarea {
    width: 100%;
    min-height: 90px;
    padding: 10px 12px;
    border: 1px solid #d7e0f0;
    border-radius: 8px;
    resize: vertical;
  }

  .hint {
    color: #777;
    font-size: 12px;
  }

  .required_mark {
    color: #c62828;
  }
}

.booking-back-btn:hover {
  transform: translateX(-2px);
}

.single_step_form_content_wrapper {
  padding: 22px;
  border: 1px solid #e2e9f8;
  border-radius: 14px;
  background: radial-gradient(circle at top right, #f8fbff 0%, #ffffff 42%);
  box-shadow: 0 12px 24px rgba(16, 42, 76, 0.06);
}

.booking-section-title {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 44px;
  margin-bottom: 14px !important;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #e2eaf7;
  background: linear-gradient(90deg, #f3f8ff 0%, #ffffff 100%);
  color: #1d2d50;
  font-size: 19px;
  font-weight: 700;
  box-shadow: 0 6px 12px rgba(22, 50, 92, 0.05);
  gap: 5px;
}

.booking-section-title::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 20px;
  margin-right: 10px;
  border-radius: 6px;
  background-color: #2f80ed;
  right: -4px;
}

.booking-section-subtitle {
  display: inline-flex;
  align-items: center;
  padding-bottom: 6px;
  border-bottom: 2px solid #dfe7f5;
  color: #243b64;
  font-size: 14px;
  font-weight: 700;
}

body.dark_theme ::v-deep .single_show_content_wrapper,
.v-application.theme--dark ::v-deep .single_show_content_wrapper {
  background: transparent;
}

body.dark_theme ::v-deep .booking-page-header,
.v-application.theme--dark ::v-deep .booking-page-header {
  border-color: #2a3857;
  background: linear-gradient(135deg, #1b2436 0%, #111a2a 100%);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
}

body.dark_theme ::v-deep .booking-page-title,
.v-application.theme--dark ::v-deep .booking-page-title {
  color: #e7efff;
}

body.dark_theme ::v-deep .booking-back-btn,
.v-application.theme--dark ::v-deep .booking-back-btn {
  color: #e6eeff !important;
  border-color: #3a4b71 !important;
  background: #0c1016 !important;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.24);
}

body.dark_theme ::v-deep .single_step_form_content_wrapper,
.v-application.theme--dark ::v-deep .single_step_form_content_wrapper {
  border-color: #2b3958;
  background: radial-gradient(circle at top right, #18243a 0%, #111a2a 42%);
  box-shadow: 0 16px 26px rgba(0, 0, 0, 0.3);
}

body.dark_theme ::v-deep .booking-section-title,
.v-application.theme--dark ::v-deep .booking-section-title {
  border-color: #314367;
  background: linear-gradient(90deg, #1c2a43 0%, #152238 100%);
  color: #e4edff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

body.dark_theme ::v-deep .booking-section-title::before,
.v-application.theme--dark ::v-deep .booking-section-title::before {
  background-color: #6aa6ff;
}

body.dark_theme ::v-deep .booking-section-subtitle,
.v-application.theme--dark ::v-deep .booking-section-subtitle {
  color: #d9e6ff;
  border-bottom-color: #3a4b70;
}

body.dark_theme ::v-deep .vehicle-image,
.v-application.theme--dark ::v-deep .vehicle-image {
  border-color: #324467;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.3);
}

body.dark_theme ::v-deep .vehicle-image:hover,
.v-application.theme--dark ::v-deep .vehicle-image:hover {
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.36);
}

@media (max-width: 768px) {
  .booking-page-title {
    font-size: 18px;
  }

  .single_step_form_content_wrapper {
    padding: 16px;
  }

  .booking-section-title {
    font-size: 16px;
    min-height: 40px;
    padding: 8px 12px;
  }
}
</style>

<style>
body.dark_theme .single_show_content_wrapper .booking-page-header,
.v-application.theme--dark .single_show_content_wrapper .booking-page-header {
  border-color: #2a3857 !important;
  background: linear-gradient(135deg, #1b2436 0%, #111a2a 100%) !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28) !important;
}

body.dark_theme .single_show_content_wrapper .booking-page-title,
.v-application.theme--dark .single_show_content_wrapper .booking-page-title {
  color: #e7efff !important;
}

body.dark_theme .single_show_content_wrapper .booking-back-btn,
.v-application.theme--dark .single_show_content_wrapper .booking-back-btn {
  color: #e6eeff !important;
  border-color: #3a4b71 !important;
  background: #1a1b1d !important;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.24) !important;
}

body.dark_theme .single_show_content_wrapper .single_step_form_content_wrapper,
.v-application.theme--dark
  .single_show_content_wrapper
  .single_step_form_content_wrapper {
  border-color: #515255 !important;
  background: radial-gradient(
    circle at top right,
    #18243a 0%,
    #111a2a 42%
  ) !important;
  box-shadow: 0 16px 26px rgba(0, 0, 0, 0.3) !important;
}

body.dark_theme .single_show_content_wrapper .booking-section-title,
.v-application.theme--dark .single_show_content_wrapper .booking-section-title {
  border-color: #314367 !important;
  background: linear-gradient(90deg, #1c2a43 0%, #152238 100%) !important;
  color: #e4edff !important;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

body.dark_theme .single_show_content_wrapper .booking-section-title::before,
.v-application.theme--dark
  .single_show_content_wrapper
  .booking-section-title::before {
  background-color: #6aa6ff !important;
}

body.dark_theme .single_show_content_wrapper .booking-section-subtitle,
.v-application.theme--dark
  .single_show_content_wrapper
  .booking-section-subtitle {
  color: #d9e6ff !important;
  border-bottom-color: #3a4b70 !important;
}

body.dark_theme .single_show_content_wrapper .vehicle-image,
.v-application.theme--dark .single_show_content_wrapper .vehicle-image {
  border-color: #324467 !important;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.3) !important;
}

body.dark_theme .single_show_content_wrapper .vehicle-image:hover,
.v-application.theme--dark .single_show_content_wrapper .vehicle-image:hover {
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.36) !important;
}
</style>
